<script lang="ts">
  import MultiSelect from "$app/components/MultiSelect.svelte"
  import { pluralizeBy, toast, xhr } from "$app/utils"
  import { appStore } from "$app/store.svelte"

  interface Props {
    department: DepartmentType
    onupdate: (department: DepartmentType) => void
  }

  let { department, onupdate }: Props = $props()

  let users: UserType[] = appStore.users
  let selectedUsers = users.filter((op) => {
    return department.user_ids.includes(op.id)
  })

  let options: UserType[] = $state([])
  options = users.filter(
    (u) => !u.deleted && !department.user_ids.includes(u.id)
  )

  let selectedUserIds = selectedUsers.map((u) => u.id).sort()
  function handleSelect(detail): void {
    selectedUserIds = detail.map((d) => d.id).sort()
  }

  let saving = $state(false)
  async function updateDepartmentUsers(): Promise<void> {
    if (!selectedUserIds) {
      return
    }
    saving = true
    let user_ids = selectedUserIds
    try {
      const resp = await xhr.patch(
        `/plans/${appStore.plan.id}/department_users/${department.id}`,
        {
          department: { user_ids }
        }
      )

      toast("Users successfully updated", "success")
      onupdate(resp.data)
    } catch (e) {
      toast("There was an error updating the users", "error")
    } finally {
      saving = false
    }
  }
</script>

<div class="lg:min-w-xl">
  <h2 class="text-xl">
    <span class="font-semibold">{department.name}</span> Members
  </h2>

  <div class="text-gray-500 mt-2">
    {#if department.user_ids.length > 0}
      <span class="bg-gray-600 px-2 text-white rounded-full">
        {department.user_ids.length}
      </span>
      {pluralizeBy("Member", department.user_ids.length)}
    {:else}
      No members selected, type to start searching.
    {/if}
  </div>

  <div class="h-120 themed mt-2 relative">
    <MultiSelect
      {options}
      selected={selectedUsers}
      valueField="id"
      searchField="name"
      onselect={handleSelect}
      placeholder="Find members"
    >
      {#snippet selectedSnippet(option, idx)}
        <img
          src={option.avatar_thumb_url}
          alt={option.name}
          class="w-8 h-8 rounded-full inline-block mr-2 border-2"
        />
        <span>{option.name}</span>
      {/snippet}
      {#snippet optionSnippet(option, idx)}
        <div>
          <div class="flex py-2 px-4 mx-2">
            <img
              src={option.avatar_thumb_url}
              alt=""
              class="w-8 h-8 rounded-full mr-2 border-2"
            />
            <span>
              {option.name}
            </span>
          </div>
        </div>
      {/snippet}
    </MultiSelect>
  </div>

  <button
    class="btn btn-primary"
    disabled={saving}
    onclick={updateDepartmentUsers}
  >
    Update Members
  </button>
</div>
